// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1Ftk4","colMaxWidth":"Table_colMaxWidth__CpumF"};